import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { easeIn, easeOut } from '../utils/curves';
import { mediumDurationMs } from '../utils/durations';
import KeyframesMotion from './keyframes-motion';
export const slideInAnimation = (from, state, fade) => {
  const initial = state === 'entering' ? '0%' : '100%';
  const end = state === 'entering' ? '100%' : '0%';
  const fromMap = {
    top: 'translate3d(0, -100%, 0)',
    right: 'translate3d(100%, 0, 0)',
    bottom: 'translate3d(0, 100%, 0)',
    left: 'translate3d(-100%, 0, 0)'
  };
  const animateOpacity = fade === 'inout' || fade === 'in' && state === 'entering' || fade === 'out' && state === 'exiting';
  return {
    [initial]: {
      transform: fromMap[from],
      opacity: animateOpacity ? 0 : 1
    },
    [end]: {
      transform: 'none',
      opacity: 1
    }
  };
};

const SlideIn = ({
  children,
  enterFrom,
  exitTo,
  fade = 'none',
  duration = mediumDurationMs,
  animationTimingFunction = state => state === 'entering' ? easeOut : easeIn,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(KeyframesMotion, _extends({
    duration: duration,
    enteringAnimation: slideInAnimation(enterFrom, 'entering', fade),
    exitingAnimation: slideInAnimation(exitTo || enterFrom, 'exiting', fade),
    animationTimingFunction: animationTimingFunction
  }, props), children);
};

export default SlideIn;